export const config = {
	followerCountLimit: 10000, // limit followers count for performance reasons
};
